import React from "react"
import {unescapeHtmlTag} from "../../../../core/utils/tools";
import {useSelector} from "react-redux";

const SummaryList = ({title, item}) => {
  const langData = useSelector(state => state.theme.langData);

  if (Array.isArray(item)) {
    return (
      <li>
        {/*<div className="spec-set">*/}
        {/*  {unescapeHtmlTag(title)}*/}
        {/*</div>*/}
        {item.map((itm, idx) => (
          <div key={idx} className="spec-sub">
            <div className="spec-name">{unescapeHtmlTag(itm.title || title)}</div>
            <div className="spec-value">{unescapeHtmlTag(itm.name)}</div>
            <div className="spec-code">{itm.code}</div>
          </div>
        ))}
      </li>
    );
  }

  return (
    <li>
      <div className="spec-sub">
        <div className="spec-name">{unescapeHtmlTag(title)}</div>
        <div className="spec-value">
          {unescapeHtmlTag(item.name)}
        </div>
        <div className="spec-code">
          {item.code}
          {/*{item.color && <p style={{fontSize:"16px", marginTop:"14px"}}>{item.color}</p>}*/}
        </div>
      </div>
      { item.color && (
        <div className="spec-sub">
          <div className="spec-value">
            {unescapeHtmlTag(item.colorName)}
          </div>
          <div className="spec-code">
            {item.color}
            {/*{item.color && <p style={{fontSize:"16px", marginTop:"14px"}}>{item.color}</p>}*/}
          </div>
        </div>
      )}
    </li>
  );
}

export default SummaryList;
